import { useToast } from '@/hooks'
import { useDocuments, useDocumentsMutations } from '@/modules/documents'
import { useFolder } from '@/modules/folders'
import { type PresignedBlob, UploadForm } from '@/modules/upload'
import { cn } from '@/utils'

export const DocumentsUpload = () => {
  const { successToast, errorToast } = useToast()
  const folder = useFolder()
  const hasDocuments = useDocuments().length > 0
  const { createDocuments } = useDocumentsMutations()

  const onSubmit = (blobs: PresignedBlob[]) => {
    createDocuments(blobs, folder?.id || null)
      .then(() => successToast('Documents uploaded successfully'))
      .catch((error) => errorToast('Failed to upload documents', error))
  }

  return (
    <div className={cn('border-b bg-white', hasDocuments ? 'p-3' : 'p-6')}>
      <UploadForm onSubmit={onSubmit} collapsed={hasDocuments} pageWideDrop />
    </div>
  )
}
